
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-simple-feature--default--font-size:var(--body-03-font-size);
  --sic-simple-feature--default--line-height:var(--body-03-line-height);
  --sic-simple-feature--default--grid-template-colums:repeat(
    2,
    calc(1 / 2 * calc(100% - var(--layout-gap)))
  );
  --sic-simple-feature--default--layout-gap:var(--grid-gap);
  --sic-simple-feature--default--padding-block:var(--spacing-20);
  --sic-simple-feature--default--padding-block--stacked:var(--spacing-08);
  --sic-simple-feature--default--body-top-spacing:var(--spacing-06);
  --sic-simple-feature--default--cta-top-spacing:var(--spacing-08);
  --sic-simple-feature--default--cta-top-spacing--stacked:var(--spacing-05);
  --sic-simple-feature--default--cta-spacing:var(--spacing-06);
  --sic-simple-feature--default--border-radius:var(
    --border-radius-rounded-default
  );
  --sic-simple-feature--default--image-max-width:904px;
}
`;